import PhoneInput, { isValidPhoneNumber, type Country } from "react-phone-number-input";

interface PhoneInputFieldProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  errorMessage?: string;
  bgColor?: string;
  defaultCountry?: Country;  // instead of string
}

const PhoneInputField: React.FC<PhoneInputFieldProps> = ({
  label = "Phone Number",
  value,
  onChange,
  error = false,
  errorMessage,
  bgColor = "#f8f8f8",
  defaultCountry = "NG" as Country,
}) => {
  return (
    <div className="w-full">
      <fieldset
        className={`group border rounded-lg px-2 py-0 focus-within:ring-[1.5px] transition-all ${
          error
            ? "border-[#FF383C] focus-within:ring-[#FF383C]"
            : "border-[#828783] hover:border-[#3b3b3b] focus-within:ring-[#0046A7]"
        }`}
      >
        <legend
          className={`group-focus-within:text-[#0046A7] font-[400] px-1 text-[11px] sm:text-[12px] leading-[100%] font-instrument ${
            error
              ? "text-[#FF383C] group-focus-within:text-[#FF383C]"
              : "text-[#010721]"
          }`}
          style={{ backgroundColor: bgColor }} // ✅ dynamic bgColor
        >
          {label}
        </legend>

        <PhoneInput
          international
          defaultCountry={defaultCountry}
          value={value}
          onChange={(val) => onChange(val ?? "")}
          className="phone-field-input"
        />
      </fieldset>

      {error && errorMessage && (
        <p className="text-[11px] sm:text-[12px] text-[#FF383C] pl-3 mt-1">
          {errorMessage}
        </p>
      )}
    </div>
  );
};

export default PhoneInputField;
